import React, { Component } from "react";
import { Grid, Row, Col, Table } from "react-bootstrap";
import PropTypes from 'prop-types';
import Modal from 'react-responsive-modal';
import styles from './schedule.css';

import Card from "../../components/Card/Card.jsx";
import {thArray} from "../../variables/Variables.jsx";
import {connect} from "react-redux";

import {getSchedule, getCompletedSchedule, updateNote} from "../../actions/scheduleActions";
import CustomButton from "../../components/CustomButton/CustomButton";


const formatPhoneNumber = (phone) => {
  if(phone.length === 10) {

      const firstThree = phone.substring(0,3);
      const secondThree = phone.substring(3,6);
      const finalFour = phone.substring(6,10);

      return `(${firstThree}) ${secondThree}-${finalFour}`;
      
  } else if(phone.length === 11) {

      const firstNumber = phone.substring(0,1);
      const firstThree = phone.substring(1,4);
      const secondThree = phone.substring(4,7);
      const finalFour = phone.substring(7,11);

      return `${firstNumber}(${firstThree}) ${secondThree}-${finalFour}`;
      
  } else {
      return phone;
  }
}

class Schedule extends Component {

    constructor(props) {
        super(props);
        this.state = {
            open:false,
            notes: "",
            id: 0
        }
    }

  componentDidMount() {
      this.schedule = this.props.schedule;
      this.completedSchedule = this.props.completedSchedule;

      const scheduleParams = {
          installer_id:this.props.auth.installer.id,
          limit:100,
          page:1,
          session:localStorage.getItem('sessionToken'),
          sort_field:'appointment_date',
          type:'future'
      }

      const completedParams = {
          installer_id: this.props.auth.installer.id,
          limit:30,
          page:1,
          session:localStorage.getItem('sessionToken'),
          sort_field:'appointment_date',
          type:'past'
      }

      this.props.getSchedule(scheduleParams);
      this.props.getCompletedSchedule(completedParams);
  }

  onOpenModal = () => {
    this.setState({ open: true });
  };

  onCloseModal = () => {
    this.setState({ open: false });
  };

  handleChange = event => {
      this.setState({
          notes: event.target.value
      });
  }
  handleNote = (notes, id) => {
      //console.log("Trying to update note: " + notes);
      this.setState({ open: true, notes: notes, id: id });
  }

  handleSubmitNote = () => {
      console.log("We are going to submit this note!" + JSON.stringify(this.state));
      const note = {
          notes: this.state.notes,
          id: this.state.id,
          session: localStorage.sessionToken
      }
      this.props.updateNote(note);
      this.setState({ open: false });
  }

  render() {
      let schedule;
      let completedSchedule;
      const {open} = this.state;

      if (this.props.schedule.schedule.data !== undefined ) {
          schedule = this.props.schedule.schedule.data.bookings.map((prop, key) => {
              let check = <span data-notify="icon" className="pe-7s-check greenCheck" />;
              if (prop.notes === undefined || prop.notes === "") {prop.notes = ""; check = ""}

              return (
                  <tr key={key}>
                      <th>{prop.wrap_appointment_type_id === "1" ? "Install" : "Removal"}</th>
                      <th>{prop.user.firstname} {prop.user.lastname}</th>
                      <th>{formatPhoneNumber(prop.user.phone)}</th>
                      <th>{prop.user.vehicle.make_id} {prop.user.vehicle.model_id}</th>
                      <th>{prop.user.vehicle.square_feet}</th>
                      <th>{prop.campaign.name}</th>
                      {prop.wrap_appointment_type_id === 1 && <th>Install</th>}{prop.wrap_appointment_type_id === 2 && <th>Uninstall</th>}
                      <th>{prop.wrap_coverage}</th>
                      <th>{prop.appointment_date}</th>
                      <th className="apptNote" onClick={() => this.handleNote(prop.notes, prop.id)}><span data-notify="icon" className="pe-7s-note pe-2x" />{check}</th>
                  </tr>
              );
          });
      } else {
          schedule = <tr></tr>;
      }

      if (this.props.schedule.completedSchedule.data !== undefined ) {
          completedSchedule = this.props.schedule.completedSchedule.data.bookings.map((prop, key) => {
              let check = <span data-notify="icon" className="pe-7s-check greenCheck" />;
              if (prop.notes === undefined || prop.notes === "") {prop.notes = ""; check=""}
              return (
                  <tr key={key}>
                      <th>{prop.wrap_appointment_type_id === "1" ? "Install" : "Removal"}</th>
                      <th>{prop.user.firstname} {prop.user.lastname}</th>
                      <th>{formatPhoneNumber(prop.user.phone)}</th>
                      <th>{prop.user.vehicle.make_id} {prop.user.vehicle.model_id}</th>
                      <th>{prop.user.vehicle.square_feet}</th>
                      <th>{prop.campaign.name}</th>
                      {prop.wrap_appointment_type_id === 1 && <th>Install</th>}{prop.wrap_appointment_type_id === 2 && <th>Uninstall</th>}
                      <th>{prop.wrap_coverage}</th>
                      <th>{prop.appointment_date}</th>
                      <th className="apptNote" onClick={() => this.handleNote(prop.notes, prop.id)}><span data-notify="icon" className="pe-7s-note" />{check}</th>
                  </tr>
              );
          });
      } else {
          completedSchedule = <tr></tr>;
      }

    return (
      <div className="content">
          <Modal open={open} onClose={this.onCloseModal} center styles={{modal:{width:600}}} classNames={{modal: styles.customModal, overlay: styles.customOverlay}}>
              <h2>Update Notes</h2>
              <textarea rows={"7"} className="noteText" onChange={this.handleChange} value={this.state.notes}/>
              <CustomButton onClick={() => this.handleSubmitNote()}>Update</CustomButton>
          </Modal>
        <Grid fluid>
          <Row>
            <Col md={12}>
              <Card
                title="Upcoming Appointments"
                category="Jobs that need to be done"
                ctTableFullWidth
                ctTableResponsive
                content={
                  <Table striped hover>
                    <thead>
                      <tr>
                        {thArray.map((prop, key) => {
                          return <th key={key}>{prop}</th>;
                        })}
                      </tr>
                    </thead>
                    <tbody>
                        {schedule}
                    </tbody>
                  </Table>
                }
              />
            </Col>
          </Row>

            <Row>
            <Col md={12}>
              <Card

                title="Past Appointments"
                category="Jobs that got done"
                ctTableFullWidth
                ctTableResponsive
                content={
                  <Table striped hover>
                    <thead>
                      <tr>
                        {thArray.map((prop, key) => {
                          return <th key={key}>{prop}</th>;
                        })}
                      </tr>
                    </thead>
                    <tbody>
                        {completedSchedule}
                    </tbody>
                  </Table>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

Schedule.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  schedule: PropTypes.object.isRequired,
  completedSchedule: PropTypes.object.isRequired,
  getSchedule: PropTypes.func.isRequired,
  getCompletedSchedule: PropTypes.func.isRequired,
  updateNote: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  auth: state.auth,
  errors: state.errors,
  schedule: state.schedule,
  completedSchedule: state.schedule
});

export default connect(mapStateToProps, {getSchedule, getCompletedSchedule, updateNote})(Schedule);


// WEBPACK FOOTER //
// ./src/views/Schedule/Schedule.jsx